export default {
  es: {
    hero: {
      title: "LAS MEJORES SOLUCIONES ENERGÉTICAS <br> PARA EMPRESAS",
      subtitle:
        "Indaga independientemente de tu tamaño, para cada momento te ofrecemos la tarifa más económica y el mejor servicio de negocio.",
      button: "Inergízate",
    },
    tarifaEmpresa: {
      title: "ENCUENTRA TU",
      subtitle: "TARIFA EMPRESA",
      description:
        "En Iner contamos con distintas tarifas de luz dependiendo de tus necesidades y las características de tu empresa. Eso si, todas ellas, tienen algo en común, ¡Son las más económicas del mercado!",
      button1: "Ver tarifas luz",
      button2: "Ver tarifas gas",
      button3: "Ver autoconsumo",
      button4: "Inergiza tu empresa",
    },
    somos: {
      title: "SOMOS",
      subtitle: "lo mejor para tu empresa",
    },
    luz: {
      hero: "LUZ",
      title: "Te ofrecemos luz…",
      description:
        "Contamos con diferentes tarifas para que elijas la que mejor se adapta tu empresa y sus necesidades. Nosotros te guiaremos en la elección de la misma.",
      button: "MÁS INFORMACIÓN",
    },
    gas: {
      hero: "GAS",
      title: "Y también gas…",
      description:
        "Con el gas, haremos lo mismo. Cuéntanos como es tu empresa y te recomendaremos aquella tarifa más óptima.",
      button: "MÁS INFORMACIÓN",
    },
    autoconsumo: {
      title: "AUTOCONSUMO",
      description:
        "¡El autoconsumo ha llegado a tu empresa! Apuesta por la instalación de placas solares y consume la energía que tu mismo produces.",
      button: "VER AUTOCONSUMO",
    },
    muchoMas: {
      hero: "MUCHO MÁS",
      title: "Otros servicios",
      description:
        "Además para todos nuestros iners, tenemos otros muchos servicios para tu hogar que te harán la vida más fácil…",
      button: "VER SERVICIOS",
    },
    yaConfian: {
      hero: "YA CONFIAN",
      title: "en nosotros",
      subtitle: "Experiencia",
      description:
        "Para nosotros tu proyecto es el nuestro y así lo demuestran las más de 3000 empresas que ya confían en nosotros para darle a su negocio la energía que necesita cada día.",
      textoNumero: "Más de 3000 empresas ya confían en nosotros.",
      description2: "Para nosotros tu proyecto es el nuestro y así lo demuestran las más de 12.000 iners que ya confían en nosotros para darle a su hogar la energía que necesita cada día.",
      textoNumero2: "Iners",
    },
    ayuda: {
      title: "¿NECESITAS ",
      subtitle: "AYUDA?",
      description:
        "Si quieres que uno de nuestros asesores te realice un estudio personalizado ponte en contacto con nosotros y estudiaremos tu caso para ver qué es lo mejor para tu negocio.",
      button: "¿TE AYUDAMOS?",
    },
  },
  en: {},
};



// WEBPACK FOOTER //
// ./src/translations/empresas.js